import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import routes from 'utils/routes';

const useScreening = id => {
  const path = `${routes.SCREENINGS.path}/${id}`;
  const { t } = useTranslation(LOCALIZATION_PAGES.SCREENINGS);

  const { showNotification } = useRoot();
  const [
    { result: resultScreening, loading: loadingScreening, error: errorScreening, setResult: setApiScreening },
    getScreening,
  ] = useApi(path, {
    initialFetch: false,
  });

  useEffect(() => {
    if (errorScreening) {
      showNotification(
        {
          message: t('alert_screening_fetch_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [errorScreening, showNotification, t]);

  return [{ resultScreening, loadingScreening, errorScreening }, getScreening, setApiScreening];
};

export default useScreening;
